import { FC, useMemo } from 'react'

import { getFilterInfo } from 'services/utilFunctions/getFilterInfo'
import FilterSelectionList from '../../UI/Filter/FilterSelectionList'
import BaseModalActions from 'components/Modals/BaseModalActions'
import { List } from 'ui'
import { MFilters } from 'types/filterTypes'

type DropDownHeroFilterModalProps = {
  contentName: MFilters.ContentTypes
  name: string
  isOpen: boolean
}

const DropDownHeroFilterModal: FC<DropDownHeroFilterModalProps> = ({ name, contentName, isOpen }) => {
  const filterDetails = useMemo(() => getFilterInfo(name), [name])

  if (filterDetails.length === 0) return null
  return (
    <BaseModalActions>
      <List className="pb-2">
        <List.Item className="p-2">
          <div className=" overflow-auto" style={{ width: '300px' }}>
            <FilterSelectionList filter={filterDetails[0]} contentName={contentName} isOpen={isOpen} />
          </div>
        </List.Item>
      </List>
    </BaseModalActions>
  )
}

export default DropDownHeroFilterModal
